import { useState, useEffect } from 'react';
/* datas */
import { HostBackend } from '../../Routes/HostBackend.js';
import { TruncateString } from '../../Components/Public/Functions/TruncateString.js';
/* document */
import { Navigation } from '../../Components/Admin/Document/Navigation.js';
import { BackTop } from '../../Components/Public/Document/BackTop.js';
import { ScrollTop } from '../../Components/Public/Functions/ScrollTop.js';
import { Footer } from '../../Components/Public/Document/Footer.js';

export const RoutesNoSqlTest = () => {
    const hash = sessionStorage.getItem('token');
    const backend = HostBackend();
    const [datas, setDatas] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            const datasRoutes = await fetch(`${backend}/admin/test/routes/nosql`);
            const datas = await datasRoutes.json();
            setDatas(datas);
        };
        fetchData();
        ScrollTop();
    }, [backend]);
    let route, url, msg, color;
    let total = 0;
    if (hash) {
        return (
            <div className="tests">
                <Navigation entity={'noSql'} chooser={[]} />
                <div className="admin-list">
                    <div className="title">
                        <div>{`ADMIN: Routes NoSql (${datas.length})`}</div>
                    </div>
                    <div className="thead">
                        <div className="block-rows">
                            <div className="id"></div>
                            <div className="id">id</div>
                            <div className="item-status">status</div>
                            <div className="item-route">route</div>
                            <div className="item">msg</div>
                        </div>
                    </div>
                    {datas.map((el, i) => {
                        total++;
                        msg = el.error ? el.error : 'Sans erreur';
                        color = el.error ? 'error' : 'valide';
                        route = TruncateString(el.route, 50);
                        url = `https://rencontretasouris.com${el.route}`;
                        return (
                            <div key={i} className="rows">
                                <div className="block-rows">
                                    <div className="id">{total}</div>
                                    <div className="id">{el.id}</div>
                                    <div className="item-status">
                                        <div className={`status ${color}`}>{el.status}</div>
                                    </div>
                                    <div className="item-route">
                                        <a href={url} alt={`route-${i}`} title={url} target="_blank" without rel="noreferrer">{route}</a>
                                    </div>
                                    <div className="item">{msg}</div>
                                </div>
                            </div>
                        )
                    })}
                </div>
                <BackTop />
                <Footer />
            </div>
        )
    } else {
        return (<></>)
    }
}